// Lightweight Google Tag Manager dataLayer helper.
// GTM is injected via index.html using import.meta.env.VITE_GTM_ID.
// trackEvent is a no-op if GTM is not configured — safe to call always.

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

// Google Ads conversion label for "Compra"
const GOOGLE_ADS_PURCHASE_SEND_TO = "AW-304161929/FaPACJvR96scEInJhJEB";

export const GTM_ID: string | undefined = (import.meta.env.VITE_GTM_ID as string | undefined) || undefined;

export function trackEvent(event: string, params: Record<string, unknown> = {}): void {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, event_name: event, ...params });
  } catch {
    /* never throw from analytics */
  }
}

export function trackEventOnce(storageKey: string, event: string, params: Record<string, unknown> = {}): void {
  try {
    if (typeof window !== "undefined" && window.sessionStorage.getItem(storageKey)) return;
    if (typeof window !== "undefined") window.sessionStorage.setItem(storageKey, "1");
  } catch {
    /* ignore storage errors and still track */
  }
  trackEvent(event, params);
}

export function trackPageView(path: string): void {
  trackEvent("page_view", { page_path: path, page_location: typeof window !== "undefined" ? window.location.href : path });
}

export function trackPurchase(params: { transaction_id: string; value: number; currency?: string; items?: unknown[] }): void {
  const currency = params.currency || "BRL";
  trackEvent("purchase", { currency, ...params });
  // Fire Google Ads conversion (gtag.js loaded in index.html)
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: GOOGLE_ADS_PURCHASE_SEND_TO,
        value: params.value,
        currency,
        transaction_id: String(params.transaction_id || ""),
      });
    }
  } catch {
    /* never throw from analytics */
  }
}
